export enum StyleVariant {
  INLINE = 'inline',
  TOP = 'top',
}
